function getRefinedAnswers(refinedData) {
    const answers = new Set();
    for (const row of refinedData) {
        if (row.additionalInfo) {
            for (const question in row.additionalInfo) {
                answers.add(row.additionalInfo[question]);
            }
        }
    }

    const result = Array.from(answers);
    result.sort();
    return result;
}

function getRefinedQuestions(refinedData) {
    const questions = new Set();
    for (const row of refinedData) {
        if (row.additionalInfo) {
            for (const question of Object.keys(row.additionalInfo)) {
                questions.add(question);
            }
        }
    }

    const result = Array.from(questions);
    result.sort();
    return result;
}

export { getRefinedQuestions, getRefinedAnswers };